var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlidingPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 68,
    height: 68,
    rx: 6,
    fill: "#FAC1B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#F9907B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 20,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#C75E5A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 52,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#C75E5A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 52,
    width: 28,
    height: 28,
    rx: 4,
    fill: "none",
    stroke: "#C75E5A",
    strokeWidth: 2,
    strokeDasharray: "5 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidingPuzzle);
export default __webpack_public_path__ + "static/media/SlidingPuzzle.87ededb831bbe149234f16ced49ac19f.svg";
export { ForwardRef as ReactComponent };